// extracted by mini-css-extract-plugin
module.exports = {"inset":"inset_inset__c3oOC"};